module.exports = __webpack_public_path__ + "img/half skirt pleats.3f1c2fcb.png";